module.exports = __webpack_public_path__ + "img/prod-mat.56c653b5.svg";